import moment from 'moment';
import {
  ActionType,
  AutoTextField,
  FormField,
  SelectGroupField,
} from '../../../components/AutoForm/AutoFieldNew';
import {moneyFieldValueType} from '../../../components/AutoForm/AutoFormNew';
import FREQUENCY from '../../../constants/Frequency';
import {OVRecommendActionEnum} from '../../../schema-types/globalTypes';
import {MomentDate, initialFeesFieldType} from '../CreateBuilder/builderFields';

export type withdrawalFieldsType = {
  initialFee: initialFeesFieldType;
  // The selected destination is an existing BankAccount entity (DBO-1436)
  destination?: {
    id: string;
  };
  source: {
    frequency: FREQUENCY;
    maxAmount: number;
    singleClientAmount: moneyFieldValueType;
    recurringClientAmount?: moneyFieldValueType;
    crystallisedFunds?: moneyFieldValueType;
    uncrystallisedFunds?: moneyFieldValueType;
    end?: MomentDate;
    full?: boolean;
    id: string;
    parentPotId?: string;
    reason?: string;
    start?: MomentDate;
    isSaltus: boolean;
  };
};

export const withdrawalAmountField: Omit<AutoTextField, 'id' | 'label'> = {
  type: ActionType.text,
  currency: true,
  decimals: 2,
  placeholder: '0',
  initialValue: '',
  allowZero: true,
  canBeEmpty: true,
};

// COMMENTED OUT — sourcePlan removed from builderFieldsType
// export const withdrawalSourceIdField: FormField = {
//   id: `${PLAN_ACTION.WITHDRAW}.sourcePlan`,
//   label: 'sourcePlan',
//   initialValue: undefined,
//   type: ActionType.text,
// };

export const withdrawalFullField: FormField = {
  id: 'withdraw.source.full',
  label: 'Full redemption?',
  type: ActionType.radioGroup,
  initialValue: false,
  horizontal: true,
  fullWidth: true,
  horizontalOptionWidthXs: 6,
  options: [
    {label: 'Full', value: true},
    {label: 'Partial', value: false},
  ],
};

export const withdrawalFrequencyField: FormField = {
  id: 'withdraw.source.frequency',
  label: 'Frequency',
  type: ActionType.select,
  needsValue: true,

  options: [
    {
      value: FREQUENCY.SINGLE,
      label: 'Single',
    },
    {
      value: FREQUENCY.MONTHLY,
      label: 'Monthly',
    },
    {
      value: FREQUENCY.QUARTERLY,
      label: 'Quarterly',
    },
    {
      value: FREQUENCY.ANNUAL,
      label: 'Annual',
    },
  ],
  initialValue: FREQUENCY.SINGLE,
};

export const withdrawalStartField: FormField = {
  id: 'withdraw.source.start',
  label: 'Start date',
  type: ActionType.datepicker,
  fullWidth: true,
  shouldDisableDate: (day) => {
    const dateMoment = moment.utc(day);
    const date = dateMoment?.get('date');
    if (!date) {
      return true;
    }
    if (date === 1) {
      return false;
    }
    if (date === 15) {
      return false;
    }
    return true;
  },
};
export const withdrawalEndField: FormField = {
  id: 'withdraw.source.end',
  label: 'End date',
  type: ActionType.datepicker,
  fullWidth: true,
  initialValue: undefined,
};

export const withdrawalReasonField: SelectGroupField = {
  id: 'withdraw.source.reason',
  label: 'Withdrawal reason',
  type: ActionType.selectGroup,
  optionGroups: [],
  initialValue: undefined,
};
